import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { cursorFetchMore, getPageInfo } from 'utils/paginationHelper';
import { dataLoader } from 'utils/helpers';
import { NODES_PATH } from 'constants/dataPaths';
import useDebouncedFunction from 'utils/hooks/useDebouncedFunction';
import { Select } from 'ui/styled';
import { useConditionsQuery } from 'apollo/queries/CONDITIONS';
var ConditionSelect = function (_a) {
    var _b;
    var onChange = _a.onChange, disabled = _a.disabled, value = _a.value, shouldHighlight = _a.shouldHighlight, isInProgress = _a.isInProgress, skipStringify = _a.skipStringify, _c = _a.placeholder, placeholder = _c === void 0 ? 'Select' : _c;
    var _d = useState(), search = _d[0], setSearch = _d[1];
    var highlightingLogic = isInProgress && !value && shouldHighlight && 'error';
    var _e = useConditionsQuery({
        variables: { filters: { search: search } }
    }), data = _e.data, loading = _e.loading, fetchMore = _e.fetchMore;
    var conditions = ((_b = data === null || data === void 0 ? void 0 : data.conditions) === null || _b === void 0 ? void 0 : _b.nodes) || [];
    var options = conditions.map(function (_a) {
        var id = _a.id, name = _a.name;
        return ({
            value: skipStringify ? name : JSON.stringify([id, name]),
            label: name
        });
    });
    var handleSearch = useCallback(function (v) {
        if (v === '' || (v && v.length >= 3)) {
            setSearch(v);
        }
    }, []);
    var debouncedSearch = useDebouncedFunction(handleSearch, 1000);
    var onPopupScroll = function (event) {
        var target = event.target;
        if (!(target instanceof HTMLElement))
            return;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            var pageInfo = getPageInfo(['conditions'])(data);
            if (!pageInfo.hasNextPage)
                return;
            cursorFetchMore(fetchMore)({
                dataPath: ['conditions'],
                dataType: NODES_PATH,
                pageInfo: pageInfo
            });
        }
    };
    return (_jsx(Select, { showSearch: { filterOption: false, onSearch: debouncedSearch }, status: highlightingLogic, placeholder: placeholder, defaultActiveFirstOption: false, suffixIcon: false, disabled: disabled, onChange: onChange, onPopupScroll: onPopupScroll, loading: loading, notFoundContent: dataLoader(loading), value: value, options: options, "data-test": "conditionSelectDropdown" }));
};
export default ConditionSelect;
